import { setupApiInstance } from '@sv-support-sdk/api/src/instance';

import { fetchAuthToken } from './tokens';
import { API_URL, DOCHUB_API_URL } from '../config';

const instance = setupApiInstance({ baseURL: API_URL });

const dochubInstance = setupApiInstance({
  baseURL: DOCHUB_API_URL,
  headers: {},
});

instance.interceptors.request.use((config) => {
  const token = fetchAuthToken();

  // eslint-disable-next-line no-param-reassign
  config.headers.Authorization = token ? `Bearer ${token}` : null;

  return config;
});

export { dochubInstance };

export default instance;
